d3_selectionPrototype = d3.selection.prototype
d3_selectionPrototype.conditionalTransition = (duration = 500) ->
  return @ if duration is false
  @transition().duration(duration)

d3_selectionPrototype.moveToFront = -> this.each -> this.parentNode.appendChild(this)
